module.exports = __webpack_public_path__ + "static/media/mohan_pr.272cfc62.jpg";